import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import InputSelect from '../../components/InputGroup/InputSelect';
import MobileInput from '../../components/InputGroup/MobileInput';
import PhoneInput from 'react-phone-input-2';
import { requestCompanySignup } from '../../services/private/site-visit.service';
import Banner from './Banner';
import { ReactComponent as LeftArrowIcon } from '../../assets/plus_icon/leftArrow.svg';
import { toast } from 'react-toastify';

const BrokerRegistration = ({
    setChannelPartner,
    isWithCP,
    ownerName,
    setOwnerName,
    ownerMobile,
    setOwnerMobile,
    email,
    setEmail,
    name,
    setName,
    mobile,
    setMobile,
    companyName,
    setCompanyName
}) => {
    const [error, setError] = useState('');
    const [ownerMobileError, setOwnerMobileError] = useState(false);
    const [mobileError, setMobileError] = useState(false);
    const [companyError, setCompanyError] = useState('');
    const [designation, setDesignation] = useState('employee')

    console.log('registrationn   ')
    useEffect(() => {
        if (name) {
            setDesignation('employee')
        }

        if (!name && ownerName) {
            setDesignation('owner')
        }
    }, [name, ownerName]);

    const handleSubmit = async () => {
        if ((designation === 'employee' && (!name || !mobile)) || !ownerName || !ownerMobile || !companyName) {
            setError(true);
            return
        } else {
            setError(false)
        }
        if (designation === 'employee' && mobile.length < 12) {
            setMobileError(true);
            return;
        } else {
            setMobileError(false)
        }
        if (ownerMobile.length < 12) {
            setOwnerMobileError(true);
            return;
        } else {
            setOwnerMobileError(false)
        }
        const payload = {
            name: name,
            mobile: mobile,
            owner_name: ownerName,
            owner_mobile: ownerMobile,
            company_name: companyName,
            email: email
        }
        try {
            const res = await requestCompanySignup(payload)
            if (res.data.status === 200) {
                toast.success(res.data.message);
                setChannelPartner('5')
            }
        } catch (err) {
            toast.error(err.response.data.message);
            if (err.response.data.message === "You've already invited this company") {
                setChannelPartner('5')
            }
            setCompanyError(err.response.data.message)
        }
    }

    return (
        <div className=' mx-auto overflow-auto'>
            <div className='!w-full broker-info'>
                <Banner />
            </div>
            <div className='flex items-center justify-center bg-white rounded-xl !my-3 sm:!my-6 !py-6 sm:!py-12 !px-5 sm:!px-10 lg:!px-20 relative'>
                <button className='flex items-center  absolute left-4 md:left-12' onClick={() => setChannelPartner('4')}>
                    <LeftArrowIcon className='stroke-black800 rotate-180 mr-1' /> <span className='hidden sm:inline-block'>Back</span>
                </button>
                <p className='flex flex-col sm:flex-row text-lg sm:text-2xl font-semibold mb-0'>
                    Register Your Company
                </p>
            </div>
            <div className=' bg-white rounded-xl !mt-6 !p-4 md:!p-12 '>
                <div className='sm:!mt-6 space-y-4 sm:space-y-6'>
                    <div className='text-lg sm:text-2xl font-semibold text-gray800'>Enter company details</div>
                    <p className='!mb-3 text-sm sm:text-base text-[#667085]'>Send your company owner a notification to add you to the team!</p>
                    <div className={` flex flex-col font-medium position-relative`}>
                        <label className='sm:!text-lg text-base !mb-3'>Select Designation</label>
                        <div className='grid grid-cols-2 sm:flex gap-6'>
                            <div
                                className={`w-max rounded-full flex items-center text-lg border ${designation === 'employee' ? 'text-white bg-gradient-to-r from-[#684EFB] to-[#3B37F5] ' : ' bg-[#F2F3F6] text-[#666677]'}  px-4 md:!px-6 py-2 md:!py-4`}
                            >
                                <input
                                    type="radio"
                                    name="designation"
                                    id="designation1"
                                    value={'employee'}
                                    className='accent-white'
                                    checked={designation === 'employee'}
                                    onChange={() => setDesignation('employee')}
                                />
                                <label htmlFor='designation1' className='ml-1.5 sm:ml-2.5 text-sm sm:text-base font-semibold mb-0'>Employee</label>
                            </div>
                            <div
                                className={`w-max rounded-full flex items-center text-lg border ${designation === 'owner' ? 'text-white bg-gradient-to-r from-[#684EFB] to-[#3B37F5] ' : ' bg-[#F2F3F6] text-[#666677]'}  px-4 md:!px-6 py-2 md:!py-4`}
                            >
                                <input
                                    type="radio"
                                    name="designation"
                                    id="designation2"
                                    className='accent-white'
                                    value={'owner'}
                                    checked={designation === 'owner'}
                                    onChange={() => setDesignation('owner')}
                                />
                                <label htmlFor='designation2' className='ml-1.5 sm:ml-2.5 text-sm sm:text-base font-semibold mb-0'>Owner</label>
                            </div>
                        </div>
                    </div>
                    <div className='w-full flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-6'>
                        {designation === 'employee' && <div className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                            <label className='sm:!text-lg text-base !mb-3 '>CP Name<sup className='text-red'>*</sup></label>
                            <input
                                className={`border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                                type={"text"}
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder={'Enter Your Name'}
                            />
                            {error && !name && (
                                <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter CP Name</div>

                            )}
                        </div>}
                        {designation === 'employee' && <div className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                            <label className='sm:!text-lg text-base !mb-3 '>Mobile No.<sup className='text-red'>*</sup></label>

                            <PhoneInput
                                inputClass={'border !w-full !font-medium focus:outline-none focus:border-primary rounded-xl text-input !h-[38px] sm:!h-[54px] text-sm sm:!text-base sm:placeholder:!text-base placeholder:!text-sm  !py-2 sm:!py-3'}
                                // containerClass={classname}
                                country={'in'}
                                value={mobile}
                                countryCodeEditable={false}
                                enableSearch={true}
                                disableSearchIcon={true}
                                onChange={phone => {
                                    setMobile(phone)
                                }}
                            />
                            {error && !mobile && (
                                <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Mobile No.</div>
                            )}
                            {
                                mobileError && mobile && <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Valid Mobile No.</div>
                            }
                        </div>}
                    </div>

                    <div className='w-full flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-6'>
                        <div className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                            <label className='sm:!text-lg text-base !mb-3 '>Owner Name <sup className='text-red'>*</sup></label>
                            <input
                                className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                                type={"text"}
                                placeholder={`${designation === 'owner' ? 'Enter Your Name' : 'Enter Owner Name'}`}
                                name='company'
                                value={ownerName}
                                onChange={(e) => setOwnerName(e.target.value)}
                            />
                            {error && !ownerName && (
                                <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Owner Name</div>

                            )}
                        </div>
                        <div className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                            <label className='sm:!text-lg text-base !mb-3 '>CP Firm Name<sup className='text-red'>*</sup></label>
                            <input
                                className={`border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                                type={"text"}
                                placeholder={'Enter CP Firm Name'}
                                name='company'
                                value={companyName}
                                onChange={(e) => setCompanyName(e.target.value)}
                            />
                            {error && !ownerName && (
                                <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter CP Firm</div>

                            )}
                        </div>

                    </div>
                    <div className={`flex flex-col font-medium relative w-full`}>
                        <label className='sm:!text-lg text-base !mb-3 '>Owner Mobile No.<sup className='text-red'>*</sup></label>

                        <PhoneInput
                            inputClass={'border !w-full !font-medium focus:outline-none focus:border-primary rounded-xl text-input !h-[38px] sm:!h-[54px] text-sm sm:!text-base sm:placeholder:!text-base placeholder:!text-sm  !py-2 sm:!py-3'}
                            // containerClass={classname}
                            country={'in'}
                            value={ownerMobile}
                            countryCodeEditable={false}
                            enableSearch={true}
                            disableSearchIcon={true}
                            onChange={phone => {
                                setOwnerMobile(phone)
                            }}
                        />
                        {error && !ownerMobile && (
                            <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Owner Mobile No.</div>

                        )}
                        {
                            ownerMobileError && ownerMobile && <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Valid Mobile No.</div>
                        }
                        {
                            companyError && <div className="text-red sm:!text-sm text-xs !mt-4">{companyError}</div>
                        }
                    </div>
                    <div className={`flex flex-col font-medium relative w-full`}>
                        <label className='sm:!text-lg text-base !mb-3 '>Email (optional)</label>

                        <input
                            className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                            type={"text"}
                            placeholder={'Enter Email'}
                            name='company'
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />

                    </div>
                </div>

                <div className='w-full justify-center !mt-6 sm:!mt-20 flex flex-col-reverse sm:flex-row items-center sm:space-x-6 space-y-4 space-y-reverse sm:space-y-0'>

                    <button
                        className='w-full sm:w-[1/2] text-base sm:!text-lg border rounded-xl !py-2 sm:!py-3.5' onClick={() => {
                            setName('')
                            setCompanyName('')
                            setMobile('')
                            setOwnerName('')
                            setOwnerMobile('')
                            setEmail('');
                            setChannelPartner('4')
                        }}>Back</button>
                    <button className='w-full sm:w-[1/2] text-base sm:!text-lg rounded-xl !py-2 sm:!py-3.5 bg-blue-900 text-white' onClick={() => {
                        if (designation === 'owner') {
                            setName('');
                            setMobile('');
                        }
                        handleSubmit()
                    }}>Next</button>

                </div>
            </div>

        </div>


    )
}

export default BrokerRegistration